export type SortType = 'ASC' | 'DESC'

type LinksResponse = {
  current: string
}

export type MetaResponse<T> = {
  page: number
  limit: number
  sortBy: Array<Array<keyof T | SortType>>
  totalItems: number
  totalPages: number
  hasNextPage: boolean
  hasPreviousPage: boolean
}

export type PaginatedResponse<T> = {
  data: T[]
  links: LinksResponse
  meta: MetaResponse<T>
}

export interface PaginatedQueryParams {
  page: number
  limit: number
  offset?: number
  search?: string
  orderBy?: string
  orderDirection?: 'asc' | 'desc'
  isDebug?: boolean
}

export interface PaginatedQueryParamsWithCachePreference
  extends PaginatedQueryParams {
  preferCache?: boolean
}

export interface ShopifyPaginatedQueryParams {
  page: number
  limit: number
  search?: string
  orderBy?: string
  orderDirection?: 'asc' | 'desc'
  nextPage: boolean
  prevPage: boolean
  cursor: string
}

export interface ProductsFilterType {
  is_cheap?: string
  filter_change?: string
  filter_stock?: string
  filter_match?: string
  filter_favorites_only?: string // 'on'
  filter_url_status?: string // 'Yes' | 'No'
  filter_my_url_status?: string // 'Yes' | 'No'
  filter_competitor_url_status?: string // 'Yes' | 'No'
  product_name?: string
  product_name_operator?: string
  product_code_operator?: string
  product_barcode_operator?: string
  category?: string
  product_code?: string
  brand?: string
  product_barcode?: string
  tag?: string
  tag_filter_operator?: string
  company?: string
  company_filter_operator?: string
  filter_ismine?: string
  my_stock?: string | number
  competitor_stock?: string | number
  competitor_price_min?: number
  competitor_price_max?: number
  competitor_total_price_min?: number
  competitor_total_price_max?: number
  product_filter_operator?: string
  competitor_filter_operator?: string
  section_filter_operator?: string
  my_price_min?: number
  my_price_max?: number
  my_price_operator?: string
  competitor_price_operator?: string
  price_min?: number
  price_max?: number
  index_min?: number
  index_max?: number
  cost_min?: number
  cost_max?: number
  total_price_min?: number
  total_price_max?: number
  has_barcode?: number | string
  my_change?: string
  competitor_change?: string
  competitor_filter_change?: string
  competitor_filter_stock?: string
}

export type FilterFormType = Partial<
  Record<keyof ProductsFilterType, string | any>
>

export type ProductsRequestParamsType = Partial<
  PaginatedQueryParams & ProductsFilterType & { search: string }
>

export type ProductLiveSmartPriceFilterType = PaginatedQueryParams & {
  brand?: string
  category?: string
  collection?: string
  product?: string
}

export type ProductDropdownOnSPRuleFilterType = PaginatedQueryParams & {
  shopify_status?: string
}

interface ReportListFilterType extends PaginatedQueryParams {
  name?: string
  is_cheap?: string
  min_price?: number
  max_price?: number
}

export interface CategoryReportListFilterType extends ReportListFilterType {
  id?: string
}

export interface BrandReportListFilterType extends ReportListFilterType {
  id?: string
}

export const PositionMap: Record<number, string> = {
  1: "I'm Cheapest",
  2: "I'm Cheaper",
  3: 'Average',
  4: "I'm higher",
  5: "I'm highest",
  6: 'All equal',
}
